import { gql } from "@apollo/client";

export default gql`
  query getComplianceProgram($complianceProgramId: Int!) {
    complianceProgram(pk: $complianceProgramId) {
      id
      title
      created
      updated
      dueDate
      startDate
      periodStartDate
      periodEndDate
      ongoing
      startDateOffset
      startDateDueDateOffset
      startDatePeriodStartOffset
      startDatePeriodEndOffset
      state
      recurrence
      creator {
        id
        name
        email
        avatar
      }
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      canReadDetails {
        permission
        reason
      }
      appliesTo
      appliesToTeams {
        edges {
          node {
            id
            title
          }
        }
      }
      appliesToManagers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      appliesToUsers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      excludedUsers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      excludedHireDateAfter
      requiredTopicTemplates {
        edges {
          node {
            id
            title
          }
        }
      }
      performanceAssessmentTemplate {
        id
        assessmentType
        anonymity
        providers
        delivery
        hasSelfAssessment
        isOnlySelfAssessment
        questionSets {
          edges {
            node {
              id
            }
          }
        }
        enableRoleBasedAssessments
        enableGoalAssessments
        roleBasedAssessmentsAssessNextRole
        roleBasedAssessmentScale
        roleBasedAssessmentScaleLabels
        roleBasedAssessmentScaleStartsAt
        competencyAssessmentType
        nextRoleCompetencyAssessmentType
      }
      engagementSurveyTemplate {
        id
        assessmentType
        anonymity
        providers
        delivery
      }
      managerAssessmentTemplate {
        id
        assessmentType
        anonymity
        providers
        delivery
      }
      peerAssessmentTemplate {
        id
        assessmentType
        anonymity
        providers
        delivery
      }
    }
  }
`;
